import { useState } from 'react';
/**
 * Хук, возвращающий предыдущее значение `value` и перезапускающий рендер компонента.
 * Позволяет синхронно обновлять состояние компонента при изменении `value`.
 *
 * NOTE: Предыдущее значение будет доступно в рендере и не будет доступно в любых эффектах.
 * За счет этого хук позволяет избежать коммита неконсистентного интерфейса в DOM.
 *
 * @param value Текущее значение `value`
 * @param defaultValue Значение по умолчанию
 * @returns Предыдущее значение `value`
 * @example
 * ```ts
 * function Component({ name }: { name: string }) {
 *     const [value, setValue] = useState<string>(name);
 *     const prevValue = usePreviousState(name);
 *
 *     // При изменении пропса сбрасываем состояние внутри компонента
 *     if (name !== prevValue) {
 *         setValue(name);
 *     }
 *
 *     return <input value={value} onChange={e => setValue(e.target.value)} />;
 * }
 * ```
 */
export function usePreviousState(value, defaultValue = value) {
    const [previousValue, setPreviousValue] = useState(defaultValue);
    if (value !== previousValue) {
        setPreviousValue(value);
    }
    return previousValue;
}
